
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/privacy/subprocessors/company-subprocessors",
      function () {
        return require("private-next-pages/terms/privacy/subprocessors/company-subprocessors.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/privacy/subprocessors/company-subprocessors"])
      });
    }
  